// extracted by mini-css-extract-plugin
export default {"whyUs":"styles_whyUs__y7iqv","itemsCon":"styles_itemsCon__ZWHKQ","list":"styles_list__05CYL","listItem":"styles_listItem__yB2gk","icon":"styles_icon__qEGGQ"};